import {store as AppStore} from '../../store/store';
import {LeadInput} from '../../gql/pwa/graphql.ts';
import {formatISO, parse} from 'date-fns';
import {Planner} from '../../network/planner.ts';

export async function storeAppointmentData(store: typeof AppStore, formData: FormData) {
    const locationId = formData.get('location_id') as string;
    const specialtyId = formData.get('specialty_id');
    const vehicleId = formData.get('vehicle_id');
    const licensePlate = formData.get('license_plate');
    const mileage = formData.get('mileage');
    const mainActivityId = formData.get('main_activity_id');
    const subActivityIds = (formData.get('sub_activity_ids') as string).split(',');
    const replacementVehicleId = formData.get('replacement_vehicle_id');
    const remarks = formData.get('remarks');
    const date = formData.get('date');
    const time = formData.get('time');
    const dateIso8601 = date && time && parse(time as string, 'H:m', parse(date as string, 'yyyy-MM-dd', new Date()));
    const me = store.getState().customerInfo.me;
    const customerId = me?.customer?.id || null;
    const customerEmail = me?.email || null;

    const appConfig = store.getState().appConfig;
    const leadType = 'appointment_request';
    const leadProvider = appConfig?.leadProviders?.find((leadProvider) => leadProvider?.name === 'PWA');
    const leadState = 'closed';

    if (customerId === null || customerEmail === null) {
        throw new Error('No customer ID found');
    }
    if (
        locationId === null ||
        vehicleId === null ||
        mileage === null ||
        mainActivityId === null ||
        subActivityIds === null ||
        replacementVehicleId === null ||
        remarks === null ||
        date === null ||
        time === null ||
        !leadProvider
    ) {
        throw new Error('Invalid data');
    }

    const leadData: LeadInput = {
        customer_id: customerId,
        lead_provider_id: leadProvider.id,
        lead_type: leadType,
        state: leadState,
        leadData: [
            {key: 'activity', value: mainActivityId as string},
            {key: 'sub_activities', value: subActivityIds.join(',')},
            {key: 'replacement_vehicle', value: replacementVehicleId as string},
            {key: 'license_plate', value: licensePlate as string},
            {key: 'mileage', value: mileage as string},
            {key: 'remarks', value: remarks as string},
            {key: 'specialty_id', value: specialtyId as string},
            {key: 'date_iso8601', value: (dateIso8601 && formatISO(dateIso8601)) as string},
        ],
        customerData: [{key: 'email', value: customerEmail}],
    };
    await Planner.createAppointment(leadData);
}
